export const enum MaxInputLength {
    Password = 256,
    Any = 2024
}

export const enum AlertType {
    Success = 'success',
    Error = 'error'
}
